import { css } from 'emotion';

import colors from '@cobliteam/ui/theme/tokens/colors';

const icon = css`
  width: 20px;
  height: 20px;
`;

export const nonAssociatedIcon = css`
  ${icon}
  color: ${colors.gray.dark};
`;

export const associatedIcon = css`
  ${icon}
  color: ${colors.accessory[5]};
`;

export const checkbox = css`
  > div {
    gap: 0;
  }
`;
